import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const CustomModal = ({
  open,
  onClose,
  id = null,
  Component = () => <></>,
  ...others
}) => {
  return (
    <Modal
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return;
        onClose();
      }}
      disableEscapeKeyDown
      disableRestoreFocus={false}
      disableEnforceFocus={false}
      disableAutoFocus
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          // width: '90vw',
          // maxWidth: '1400px',
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          borderRadius: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'sticky',
          top: 8,
          alignSelf: 'flex-end',
          color: (theme) => theme.palette.grey[500],
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>
        <Box
          id="modal-description"
          sx={{
            overflowY: 'auto',
            maxHeight: '90vh',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': { display: 'none' },
          }}
        >
          <Component
            {...(id !== null ? { id } : {})}
            handleClose={onClose}
            {...others}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default CustomModal;
